import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExportCsv = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 2.111 6.5 1v10L1 9.889V2.11Zm6.6 1.111v-1.11H12v7.777H7.6V8.778h1.1V7.667H7.6V6.556h1.1V5.445H7.6V4.334h1.1V3.222H7.6Zm2.2 0h1.1v1.111H9.8v-1.11Zm-6.626.72h-.977l1.036 2.056L2.1 8.058h.955l.618-1.33a3.31 3.31 0 0 0 .082-.286h.01c.022.132.049.227.072.274l.612 1.341H5.4L4.304 5.982l1.065-2.04h-.892l-.566 1.221c-.055.159-.092.28-.11.36h-.014a2.456 2.456 0 0 0-.105-.35l-.508-1.23ZM9.8 5.445h1.1v1.111H9.8v-1.11Zm1.1 2.223H9.8v1.11h1.1v-1.11Z",
		fill: "var(--main-color)"
	})
});
export { SvgExportCsv as ReactComponent };
